import axios from './ajax.js'
import router from '../router'
import store from '../store';
import qs from 'qs'
import md5 from 'js-md5';
import {
  Toast,
  Dialog
} from 'vant';
import {REQUEST_URL as API} from "@/assets/api";
    
/** 访问域名 */
const BETA_DOMAIN = "betaspps.bosiny.com.cn"; // 测试
const OFFCIAL_DOMAIN = "spps.bosiny.com.cn"; //正式
const NANCHONG_DOMAIN = "spps.ncgzzh.com"; //南充
const _host = window.location.hostname

const ApiUrl = {
  url: API
};

const commonUtil = {
  isDevMode(){
    return (_host != OFFCIAL_DOMAIN && _host != BETA_DOMAIN && _host != NANCHONG_DOMAIN )
  },
  updateUserInfo(data){
    data && store.commit("setUserInfo", data);
  },
  isLogin(){
    if (store.state.loginStatus) {
      return true
    }
    const _store = this.getCookie('store');
     //页面刷新或者被关闭后重新打开需要直接读取cookie store数据还原在登录判断之后(app.vue created 周期中)
    if (_store && JSON.parse(_store).loginStatus) {
      return true
    }
    return false;
  },
  //注销
  logout(){
    store.commit("logout", '');
    this.delCookie("store");
    sessionStorage.removeItem('routerName');
  },
  init() {

    //扫码新增逻辑，将url中呆的appid和devid存入本地
    let scan_appid = '';
    if(!this.getUrlKey("cusid") && !this.getUrlKey("trxid")){ // 湖州银行 支付成功返回首页不取appid
      scan_appid = this.getUrlKey("appid");
    }
    let scan_devid = this.getUrlKey("devid");
    //无人值守新增参数
    let scan_time = this.getUrlKey("time");
    let scan_mac = this.getUrlKey("mac");
    let scan_id = this.getUrlKey("id");
    let scan_type = this.getUrlKey("type");
    let scan_cardno = this.getUrlKey("cardno");
    //扫码优惠领取优惠券参数
    let scan_mode = this.getUrlKey("mode");
    let coupon_type = this.getUrlKey("coupon_type");
    let coupon_value = this.getUrlKey("coupon_value");
    let coupon_validhours = this.getUrlKey("coupon_validhours");
    let phonenumber = this.getUrlKey("phonenumber");
    let generated_time = this.getUrlKey("generated_time");
    let expire_time = this.getUrlKey("expire_time");
    let start_time = this.getUrlKey("start_time");
    if (scan_appid) {
      sessionStorage.setItem("appid", scan_appid);
    }
    if (scan_devid) {
      sessionStorage.setItem("devid", scan_devid);
    }
    if (scan_time) {
      sessionStorage.setItem("time", scan_time);
    }
    if (scan_mac) {
      sessionStorage.setItem("mac", scan_mac);
    }
    if (scan_id) {
      sessionStorage.setItem("id", scan_id);
    }
    if (scan_type) {
      sessionStorage.setItem("type", scan_type);
    }
    if (scan_cardno) {
      sessionStorage.setItem("cardno", scan_cardno);
    }

    if (scan_mode) {
      sessionStorage.setItem("mode", scan_mode);
    }
    if (coupon_type) {
      sessionStorage.setItem("coupon_type", coupon_type);
    }
    if (coupon_value) {
      sessionStorage.setItem("coupon_value", coupon_value);
    }
    if (coupon_validhours) {
      sessionStorage.setItem("coupon_validhours", coupon_validhours);
    }
    if (phonenumber) {
      sessionStorage.setItem("phonenumber", phonenumber);
    }
    if (generated_time) {
      sessionStorage.setItem("generated_time", generated_time);
    }
    if (expire_time) {
      sessionStorage.setItem("expire_time", expire_time);
    }
    if (start_time) {
      sessionStorage.setItem("start_time", start_time);
    }
    // 判断浏览器类型
    if (this.browserType() == "wx") {
      this.getoriginalId();
    } else if (this.browserType() == "al") {
      this.aliuserid()
    }

    // ----开发这模式 mock 数据  start -----------
    store.commit('setDevMode',this.isDevMode())
    if (store.state.isDevMode) {
      store.commit('getBrowerType','wx')
      store.commit('setOriginalId','o0b1TwWxOg7gmDXycxEUFXGO8MSI')  // 峰的个人微信 openid
      sessionStorage.setItem("originalId", 'o0b1TwWxOg7gmDXycxEUFXGO8MSI');
    } else {
      store.commit('getBrowerType',this.browserType())
      store.commit('setOriginalId', sessionStorage.getItem("originalId"))
    }
    // ----开发这模式 mock 数据  end -----------

  },
  browserType() { // 判断浏览器类型
    if (/MicroMessenger/.test(window.navigator.userAgent)) { //微信
      return  "wx";
    } else if (/AlipayClient/.test(window.navigator.userAgent)) { //支付宝
      return  "al";
    } else {
      return  "other"
    }
  },
  setCookie(c_name,value,expiredays){
      var exdate=new Date()
      //exdate.setDate(exdate.getDate()+expiredays);//按天
      exdate = new Date(exdate.getTime()+expiredays*1000*60*60*24);//按毫秒
      document.cookie=c_name+ "=" +escape(value)+((expiredays==null) ? "" : ";expires="+exdate.toGMTString());
  },
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=")
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1
        let c_end = document.cookie.indexOf(";", c_start)
        if (c_end == -1) c_end = document.cookie.length
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ""
  },

  delCookie: function (c_name) {
    this.setCookie(c_name, "", -1)
  },
  isEmpty: function (s) {
    if (s == undefined || s == null || s == "" || s == "null" || s == 'undefined')
      return true;
    return false;
  },
  getUrlParam: function (url, name) {

    var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
    var matcher = pattern.exec(url);
    var items = null;
    if (null != matcher) {
      try {
        items = decodeURIComponent(decodeURIComponent(matcher[1]));
      } catch (e) {
        try {
          items = decodeURIComponent(matcher[1]);
        } catch (e) {
          items = matcher[1];
        }
      }
    }
    return items;
  },
  queryajax(carNum,id) {
    var loadinginstace = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    var appid = sessionStorage.getItem("appid");
    
    var url = ApiUrl.url + "/api/js/feemount";
    //let devid=this.getCookie("devid");
    let devid = sessionStorage.getItem("devid");
    let originalId = sessionStorage.getItem("originalId");
    // let id = sessionStorage.getItem("id");
    let os = sessionStorage.getItem("os");//来源 app：公众号 “”：肥公众号
    let encStr = 'appid=""&originalId='+(originalId?originalId: '')+'&key=02468ACE13579BDF'
    let signStr = md5(encStr.toUpperCase()).substring(0, 8)
    var req = {
      carNum: carNum,
      appid: appid,
      sign: signStr
    }
    if(os){
      req.os = os
    }
    if (id) {
      req.id = id
    }
    if (devid) {
      req.devid = devid
    }
    if(originalId){//用户保存用户信息
      req.originalId = originalId
    }

    axios({
      method: 'post',
      url: url,
      data: req,
      success:function(result){
        
        loadinginstace.clear();
        if (result.code == 0) {
          if (result.resultcode == '0000') {
            var datas = result.data;
            var projectDo = result.projectDo;
            let indate = datas.indate,
              intime = datas.intime;
            let acdate = indate.substring(0, 4) +
              "-" +
              indate.substring(4, 6) +
              "-" +
              indate.substring(6, 8);
            let actime =
              intime.substring(0, 2) +
              ":" +
              intime.substring(2, 4) +
              ":" +
              intime.substring(4, 6);
            let dateIn = acdate + " " + actime;
            let totalMinute = datas.times % 60,
              totalHours = Math.floor(datas.times / 60);
            let totalTime = totalHours + "小时" + totalMinute + "分钟";
            let totalfee = datas.lastfee;
            sessionStorage.setItem("payfee",totalfee);
            let parkingname = datas.parkingname;
            if (datas.appid) { //微信下单appid
              //this.setCookie("appid", datas.appid, 3000);
              sessionStorage.setItem("appid", datas.appid);
            }
            this.setCookie("parkingname", parkingname, 30);
            this.setCookie("dateIn", dateIn, 30);
            this.setCookie("totalTime", totalTime, 30);
            this.setCookie("totalfee", datas.totalfee, 30);
            //查询成功后将车牌号存入本地，保存30天
            this.setCookie("carNum2", carNum, 30);
            this.setCookie("inurl", datas.inurl, 30);
            this.setCookie("discfee", datas.discfee, 30);
            this.setCookie("freePayPermission", result.freePayPermission, 300);
            this.setCookie("lastfee", datas.lastfee, 30);
            this.setCookie("historyfee", datas.historyfee, 30);
            //锁车新增
            this.setCookie("id", datas.commid, 30);
            this.setCookie("lockStatus", datas.lock, 30);
  
  
            //先清除cookie
            this.delCookie("weixinPaystate");
            this.delCookie("alipayPaystate");
            this.delCookie("bbcPaystate");
            this.delCookie("icbcPaystate");
            this.delCookie("unionPaystate");
            this.delCookie("ccbqrPaystate");
            this.delCookie("bocqrPaystate");//中国银行聚合支付
            this.delCookie("bocPaystate");//中国银行卡支付
            //store.commit("setPayList",projectDo);
            sessionStorage.setItem("payList","");
            if (!this.isEmpty(projectDo)) {
              sessionStorage.setItem("payList",JSON.stringify(projectDo));
              for (let i = 0; i < projectDo.length; i++) {
                if (projectDo[i] == 'WX') {
                  this.setCookie("weixinPaystate", "WX", 30);
                }
                if (projectDo[i] == "AL") {
                  this.setCookie("alipayPaystate", "AL", 30);
                }
                if (projectDo[i] == "CCB") {
                  this.setCookie("bbcPaystate", "CCB", 30);
                }
                if (projectDo[i] == "ICBC") {
                  this.setCookie("icbcPaystate", "ICBC", 30);
                }
                if (projectDo[i] == "UNION") {
                  this.setCookie("unionPaystate", "UNION", 30);
                }
                if (projectDo[i] == "CCBQR") {
                  this.setCookie("ccbqrPaystate", "CCBQR", 30);
                }
                if (projectDo[i] == "BOCQR") {//中国银行聚合支付
                  this.setCookie("bocqrPaystate", "BOCQR", 30);
                }
                if (projectDo[i] == "BOC") {//中国银行卡支付
                  this.setCookie("bocPaystate", "BOC", 30);
                }
              }
              //新增中行支付
              let str = projectDo.join(",");
              if(str.indexOf("CCBQR") >= 0 && str.indexOf("BOCQR") >= 0){//建行支付和中国银行支付同时存在
                if(str.indexOf("CCBQR") > str.indexOf("BOCQR")){//谁在后面就删掉谁
                  this.delCookie("ccbqrPaystate");//建行
                }else{
                  this.delCookie("bocqrPaystate");//中国银行
                }
              }
            }
            if (totalfee == '0.00') {
              Dialog.alert({
                title: '提示',
                message: '该车辆暂未产生停车费用,最终费用以车辆本次在场累计时间为准'
              })
  
            } else {
              router.push({
                name: 'paydetail',
                params: {
                  page: 'index',
                }
              });
            }
          }
        } else if (result.code == '500') {
          Toast({
            duration: 1200,
            message: result.msg
            //message: '未查到车辆信息'
          });
        } else {
          Toast({
            duration: 1200,
            message: '查询信息失败，请检查车牌号是否输入有误'
          });
        }
      }.bind(this),
      error:function(error){
        Toast({
          duration:1200,
          message: '连接服务器超时，请稍后再试'
        });
      }
    })
  },
  indetailquery: function (carNum) { //入场通知查询
    var loadinginstace = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    var url = ApiUrl.url + "/api/js/feemount";
    let originalId = sessionStorage.getItem("originalId");
    let os = sessionStorage.getItem("os");//来源 app：公众号 “”：肥公众号

    let encStr = 'appid=""&originalId='+(originalId?originalId: '')+'&key=02468ACE13579BDF'
    let signStr = md5(encStr.toUpperCase()).substring(0, 8)
    var req = {
      carNum: carNum,
      originalId: originalId,
      sign: signStr
    }
    if(os){
      req.os = os
    }

    axios({
      method: 'post',
      url: url,
      data: req,
      success: function(result){
        loadinginstace.clear();
        if (result.code == 0) {
  
          if (result.resultcode == '0000') {
            var datas = result.data;
            var projectDo = result.projectDo;
            let totalfee = datas.lastfee;
            sessionStorage.setItem("payfee",totalfee);
            if (totalfee == '0.00' || totalfee == 0) {
                router.push({
                  name: 'inoutdetail',
                  params: {
                    page: 'index',
                  }
                });
  
            } else {
  
              let indate = datas.indate,
                intime = datas.intime;
              let acdate = indate.substring(0, 4) +
                "-" +
                indate.substring(4, 6) +
                "-" +
                indate.substring(6, 8);
              let actime =
                intime.substring(0, 2) +
                ":" +
                intime.substring(2, 4) +
                ":" +
                intime.substring(4, 6);
              let dateIn = acdate + " " + actime;
              let totalMinute = datas.times % 60,
                totalHours = Math.floor(datas.times / 60);
              let totalTime = totalHours + "小时" + totalMinute + "分钟";
              let parkingname = datas.parkingname;
              if (datas.appid) { //微信下单appid
                //this.setCookie("appid", datas.appid, 3000);
                sessionStorage.setItem("appid", datas.appid);
              }
              this.setCookie("parkingname", parkingname, 30);
              this.setCookie("dateIn", dateIn, 30);
              this.setCookie("totalTime", totalTime, 30);
              this.setCookie("totalfee", datas.totalfee, 30)
              this.setCookie("carNum2", carNum, 30);
              this.setCookie("inurl", datas.inurl, 30);
              this.setCookie("discfee", datas.discfee, 30);
              this.setCookie("lastfee", datas.lastfee, 30);
              this.setCookie("historyfee", datas.historyfee, 30);
              this.setCookie("freePayPermission", result.freePayPermission, 300);
  
  
              //先清除cookie
              this.delCookie("weixinPaystate");
              this.delCookie("alipayPaystate");
              this.delCookie("bbcPaystate");
              this.delCookie("icbcPaystate");
              this.delCookie("unionPaystate");
              this.delCookie("ccbqrPaystate");
              this.delCookie("bocqrPaystate");//中国银行聚合支付
              this.delCookie("bocPaystate");//中国银行卡支付
              //store.commit("setPayList",projectDo);
              sessionStorage.setItem("payList","");
              if (!this.isEmpty(projectDo)) {
                sessionStorage.setItem("payList",JSON.stringify(projectDo));
                for (let i = 0; i < projectDo.length; i++) {
                  if (projectDo[i] == 'WX') {
                    this.setCookie("weixinPaystate", "WX", 30);
                  }
                  if (projectDo[i] == "AL") {
                    this.setCookie("alipayPaystate", "AL", 30);
                  }
                  if (projectDo[i] == "CCB") {
                    this.setCookie("bbcPaystate", "CCB", 30);
                  }
                  if (projectDo[i] == "ICBC") {
                    this.setCookie("icbcPaystate", "ICBC", 30);
                  }
                  if (projectDo[i] == "UNION") {
                    this.setCookie("unionPaystate", "UNION", 30);
                  }
                  if (projectDo[i] == "CCBQR") {
                    this.setCookie("ccbqrPaystate", "CCBQR", 30);
                  }
                  if (projectDo[i] == "BOCQR") {//中国银行聚合支付
                    this.setCookie("bocqrPaystate", "BOCQR", 30);
                  }
                  if (projectDo[i] == "BOC") {//中国银行卡支付
                    this.setCookie("bocPaystate", "BOC", 30);
                  }
                }
                //新增中行支付
                let str = projectDo.join(",");
                if(str.indexOf("CCBQR") >= 0 && str.indexOf("BOCQR") >= 0){//建行支付和中国银行支付同时存在
                  if(str.indexOf("CCBQR") > str.indexOf("BOCQR")){//谁在后面就删掉谁
                    this.delCookie("ccbqrPaystate");//建行
                  }else{
                    this.delCookie("bocqrPaystate");//中国银行
                  }
                }
              }
              if (this.isEmpty(sessionStorage.getItem("originalId"))) {
            
                sessionStorage.setItem("toUrl","paydetail");
              }else{
                router.push({
                  name: 'paydetail'//,
                  // params: {
                  //   page: 'index',
                  // }
                });
              }
              
            }
          } else {
            Dialog.alert({
              title: '提示',
              message: '系统忙，请稍后再试！'
            })
          }
        }
        else{
          router.push({
            name: 'inoutdetail',
            params: {
              page: 'index',
            }
          });
        }
      }.bind(this),
      error: function(error){
        console.log(error)
      }
    })

  },
  wxAppid: function(){
    const devAppid = 'wxbc26bda7ccc6e744'
    const proAppid = 'wxa8746e1c7027a817'
    const nanchongAppid = 'wxcc426e1a0024486d'//南充appid
    
    if(_host == OFFCIAL_DOMAIN){
      return proAppid
    }else if(_host == NANCHONG_DOMAIN){
      return nanchongAppid
    }else{
      return devAppid
    }
  },
  addVersion: function(fromurl){
    let $sct = document.getElementsByTagName('script')
    let ver = ''
    Object.keys($sct).forEach(k=>{
      if($sct[k].src.indexOf('static/js/vendor') != -1){
        ver = $sct[k].src.split('.').reverse()[1] + '_' + new Date().getTime()
      }
    })
    let connect = fromurl.indexOf('?') != -1 ? '&v=' : '?v='
    let url = fromurl + connect + ver
    return url
  },
  isWXRedirectBack(){
    return (this.getUrlKey('?code')||this.getUrlKey('code')) && this.getUrlKey('state')
  },
  // 微信获取openid
  getoriginalId: function () {
    if(this.browserType() == 'other') return
    console.log('?code',this.getUrlKey('?code'))
    console.log('code',this.getUrlKey('code'))
    console.log('state',this.getUrlKey('state'))
    if((this.getUrlKey('?code')||this.getUrlKey('code')) && this.getUrlKey('state')){
      var code = this.getUrlKey('?code')||this.getUrlKey('code');
      var loadinginstace = Toast.loading({
        mask: true,
        message: '请求中...'
      });
      axios({
        method: 'post',
        url: ApiUrl.url +'/auth2/original_id',
        data: {
          code: code
        },
        success: function(res){
          loadinginstace.clear()
          var openid = ''
          if(res && res.openid){
            openid = res.openid
            sessionStorage.setItem("originalId",openid);
            //支付详情
            if(!this.isEmpty(sessionStorage.getItem("toUrl"))){
              var url = sessionStorage.getItem("toUrl");
              sessionStorage.setItem("toUrl","");
              router.push({name:url})
            }else{ // forward 回来之后 重新回到之前的 url(微信授权回来的页面路由在参数后面，存在问题)
              var fromurl = sessionStorage.getItem('fromurl')
              window.location.replace(fromurl)
            }
          }else{  //异常情况没有获取到 微信openid 如code重复使用等，则回到初始页面获取code
            var fromurl = sessionStorage.getItem('fromurl')
            window.location.replace(fromurl)
          }
          
          // sessionStorage.setItem("originalId",openid);
          // //支付详情
          // if(!this.isEmpty(sessionStorage.getItem("originalId")) && !this.isEmpty(sessionStorage.getItem("toUrl"))){
          //   var url = sessionStorage.getItem("toUrl");
          //   sessionStorage.setItem("toUrl","");
          //   router.push({name:url})
          // }
          // //forword回来的页面
          // if (!this.isEmpty(sessionStorage.getItem("originalId"))) { // forward 回来之后 重新回到之前的 url
          //   var fromurl = sessionStorage.getItem('fromurl')
          //   if(fromurl){
          //     window.location.replace(this.addVersion(fromurl))
          //   }
            
          // }
        }.bind(this),
        error: function(error){
          alert('微信授权失败，请重试')
        }.bind(this)
      })
    }else{
      if (this.isEmpty(sessionStorage.getItem("originalId"))) { // 第一次进页面进行forward  由访问后台 改为直接访问微信 auth2
        Toast.loading({
          mask: true,
          message: '识别中...',
          duration: 4000
        });
        var fromurl = location.href;
        sessionStorage.setItem('fromurl',fromurl)
        var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.wxAppid()+'&redirect_uri='+encodeURIComponent(fromurl)+'&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        window.location.replace(url)
      }
    //****************************************************************************************************** */
    }
    
    return sessionStorage.getItem("originalId")
  },
  wxopenid: function (appid) {
    if (this.isEmpty(sessionStorage.getItem("originalId"))) {
      return;
    }
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    var fromurl = location.href;
    if (fromurl.indexOf("?") != -1) {
      fromurl = fromurl.split("?")[0]
    }

    var url = ApiUrl.url + '/auth2/forward?two=1&payChannel=WeChatPay&appid=' + appid + '&backUri=' + encodeURIComponent(fromurl);
    window.location.replace(url)
  },
  alAppid: function(){
    const devAppid = '2015111100756292'
    const proAppid = '2016111602861222'
    if(_host == OFFCIAL_DOMAIN){
      return proAppid
    }else{
      return devAppid
    }
  },
  //支付宝获取userid
  aliuserid: function () {
    var userid = ""
    try {
      userid = this.getUrlKey("userid");
    } catch (e) {
      alert(JSON.stringify(e))
    }
    if (!this.isEmpty(userid)) {
      if (this.isEmpty(sessionStorage.getItem("originalId"))) {
        sessionStorage.setItem("originalId", userid)
      }
    }
    if (this.isEmpty(sessionStorage.getItem("originalId"))) {
      var fromurl = location.href;
      var url = ApiUrl.url + '/auth2/forward?payChannel=AliPay&appid=' + this.alAppid() + '&backUri=' + encodeURIComponent(fromurl)
      window.location.replace(url) // replace 去掉一次history
    }

    return sessionStorage.getItem("originalId")
  },
  payCommonReq: function(){ // 有空 支付通用参数 抽出来
    var req = {}
    return req
  },
  // 微信支付调用
  wxPay: function (carNum,payChannel,api) {
    var loadinginstace = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    // var wxopenid = this.getCookie("openid")
    var appid = sessionStorage.getItem("appid");
    // if(this.isEmpty(appid)){
    //   appid = this.getCookie("appid");
    // }
    var originalId = sessionStorage.getItem("originalId")
    var url = ApiUrl.url + "/api/js/parameters"
    if(api){
      url = api;
    }


    var browserType = this.browserType();
    var req = {
      browserType : browserType
    }
    //扫码新增参数devid
    //var devid=this.getCookie("devid");
    var devid = sessionStorage.getItem("devid");
    if (devid) {
      req.devid = devid
    }
    //无人值守扫码所需参数
    var id = sessionStorage.getItem("id");
    if(id){
      req.id = id
    }
    //无人值守 type=3
    var cardno =  sessionStorage.getItem("cardno");
    if(cardno){
      req.cardno = cardno
    }
    //套餐充值新增
    var my_number = sessionStorage.getItem("number");
    if(my_number){
      req.number = my_number
    }
    var spaces = sessionStorage.getItem("spaces");
    if(spaces){
      req.spaces = spaces
    }
    var tradeno = sessionStorage.getItem("tradeno");
    if(tradeno){
      req.tradeno = tradeno
    }
    var parkingno = sessionStorage.getItem("parkingno");
    if(parkingno){
      req.parkingno = parkingno
    }
    var orderId = sessionStorage.getItem("orderId");
    if(orderId){
      req.orderId = orderId
    }
    var payfee = sessionStorage.getItem("payfee");
    if(payfee){
      req.payfee = payfee
    }
    var commname = sessionStorage.getItem("commname");
    if(commname){
      req.commname = commname
    }
    var parkingname = sessionStorage.getItem("parkingname");
    if(parkingname){
      req.parkingname = parkingname
    }
    if(!payChannel){
      payChannel = "WeChatPay"
    }
    req.payChannel = payChannel
    req.carNum = carNum
    req.originalId = originalId
    req.openId = this.getUrlKey("originalId")
    req.tradeType = 'JSAPI'
    req.appid = appid
    req.scenes = 'tempparking'

    axios({
      method: 'post',
      url: url,
      data: req,
      success: function(result){
          loadinginstace.clear()
          if (result.code == 0) {
            // 获取微信支付参数
            var datas = result.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(datas), false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(datas));
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(datas));
              }
            } else {
              this.onBridgeReady(datas);
            }
          } else if(result.code == 501){
            Toast(result.msg);
          } else {
            alert("获取参失败：" + JSON.stringify(result))
          }
      }.bind(this),
      error: function(error){
        alert("ajax请求失败" + error)
      }
    })
    
  },
  onBridgeReady: function (datas) {
    var request = {
      appId: datas.signMap.appId, //公众号名称，由商户传入
      timeStamp: datas.signMap.timeStamp, //时间戳，自1970年以来的秒数
      nonceStr: datas.signMap.nonceStr, //随机串
      package: datas.signMap.package,
      signType: datas.signMap.signType, //微信签名方式：
      paySign: datas.signMap.paySign //微信签名
    };
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', request,
      //调起微信支付成功
      function (res) {
        WeixinJSBridge.log("支付" + res.err_msg);
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //alert("微信支付成功!");
          // window.location.href = "http://你的域名/weChatpay/resultServlet?openId=" + openId + "&num=" + num;
          router.push('./success');
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          // alert("用户取消支付!");
          // router.push({name:"index"});

        } else {
          alert("支付失败" + JSON.stringify(res))
          //支付失败或取消，恢复到原来的订单量
          // router.push('./index');
        }
      }
    );
  },
  // 支付宝支付调用
  aliPay: function (carNum,payChannel,api) {
    var loadinginstace = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    var appid = sessionStorage.getItem("appid");
    
    var userid = sessionStorage.getItem("originalId");
    var url = ApiUrl.url + "/api/js/parameters";
    if(api){
      url = api;
    }

    var browserType = this.browserType();
    var req = {
      browserType : browserType
    }
    //扫码新增参数devid
    //var devid=this.getCookie("devid");
    var devid = sessionStorage.getItem("devid");
    if (devid) {
      req.devid = devid
    }
    //无人值守扫码所需参数
    var id = sessionStorage.getItem("id");
    if(id){
      req.id = id
    }
    //无人值守 type=3
    var cardno =  sessionStorage.getItem("cardno");
    if(cardno){
      req.cardno = cardno
    }
    //套餐充值新增
    var my_number = sessionStorage.getItem("number");
    if(my_number){
      req.number = my_number
    }
    var spaces = sessionStorage.getItem("spaces");
    if(spaces){
      req.spaces = spaces
    }
    var tradeno = sessionStorage.getItem("tradeno");
    if(tradeno){
      req.tradeno = tradeno
    }
    var parkingno = sessionStorage.getItem("parkingno");
    if(parkingno){
      req.parkingno = parkingno
    }
    var orderId = sessionStorage.getItem("orderId");
    if(orderId){
      req.orderId = orderId
    }
    var payfee = sessionStorage.getItem("payfee");
    if(payfee){
      req.payfee = payfee
    }
    var commname = sessionStorage.getItem("commname");
    if(commname){
      req.commname = commname
    }
    var parkingname = sessionStorage.getItem("parkingname");
    if(parkingname){
      req.parkingname = parkingname
    }
    if(!payChannel){
      payChannel = "AliPay"
    }
    req.payChannel = payChannel
    req.carNum = carNum
    req.appid = appid
    req.originalId = userid
    req.openid = 'none'
    req.tradeType = 'JSAPI'
    req.scenes = 'tempparking'

    
    axios({
      method: 'post',
      url: url,
      data: req,
      success: function(result){
        loadinginstace.clear();
        var order = result.data;
        if (result.code == 0) {
          ap.tradePay({
            tradeNO: order.outTradeNo
          }, function (res) {
            // 关闭收银台之后的回调
            if (res.resultCode == 9000) {
              router.push('./success');
            } else if (res.resultCode == 6001) {
              alert("您已取消支付")
            }else{
              res && res.memo && alert(res.memo)
            }
          });
        }else if(result.code == 501){
          Toast(result.msg);
        } else {
          alert("没有查询到支付信息"+result.msg)
        }
      }.bind(this),
      error: function(error){
        
      }
    })

  },
  //银行卡支付
  bankPay: function (carNum, payChannel,api) {
    
    var loadinginstace = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    var appid = sessionStorage.getItem("appid");
    var originalId = sessionStorage.getItem("originalId");
    var openid = this.getUrlKey("originalId")
    var url = ApiUrl.url + "/api/js/parameters";
    if(api){
      url = api;
    }

    var req = {}

    var browserType = this.browserType();
    req.browserType = browserType

    //扫码新增参数devid
    //var devid=this.getCookie("devid");
    var devid = sessionStorage.getItem("devid");
    if (devid) {
      req.devid = devid
    }
    //无人值守扫码所需参数
    var id = sessionStorage.getItem("id");
    if(id){
      req.id = id
    }
    //无人值守 type=3
    var cardno =  sessionStorage.getItem("cardno")
    if(cardno) {
      req.cardno = cardno
    }
    //套餐充值新增
    var my_number = sessionStorage.getItem("number")
    if(my_number){
      req.number = my_number
    }
    var spaces = sessionStorage.getItem("spaces")
    if(spaces){
      req.spaces = spaces
    }
    var tradeno = sessionStorage.getItem("tradeno")
    if(tradeno){
      req.tradeno = tradeno
    }
    var parkingno = sessionStorage.getItem("parkingno")
    if(parkingno){
      req.parkingno = parkingno
    }
    var orderId = sessionStorage.getItem("orderId");
    if(orderId){
      req.orderId = orderId
    }
    var payfee = sessionStorage.getItem("payfee");
    if(payfee){
      req.payfee = payfee
    }
    var commname = sessionStorage.getItem("commname");
    if(commname){
      req.commname = commname
    }
    var parkingname = sessionStorage.getItem("parkingname");
    if(parkingname){
      req.parkingname = parkingname
    }

    req.payChannel = payChannel
    req.carNum = carNum
    req.appid = appid
    req.scenes = 'tempparking'
    req.openid = openid
    req.originalId = originalId
    
    axios({
      method: 'post',
      url: url,
      data: req,
      success: function(result){
        loadinginstace.clear();
        const payList = [
          {payWay: 'CCB', urlKey: 'ccbOnlinePayUrl'},
          {payWay: 'UNION', urlKey: 'qrPayUrl'},
          {payWay: 'ICBCQR', urlKey: 'qrPayUrl'},
          {payWay: 'CMBC', urlKey: 'qrPayUrl'},
          {payWay: 'HUZBQR', urlKey: 'qrPayUrl'},
          {payWay: 'SCRCBQR', urlKey: 'qrPayUrl'},
          {payWay: 'BOCWISDOMQR', urlKey: 'qrPayUrl'},
          {payWay: 'JNRCBQR', urlKey: 'qrPayUrl'},
          {payWay: 'LUZBQR', urlKey: 'qrPayUrl'},
          {payWay: 'ABC', urlKey: 'qrPayUrl'},
        ]
        for (let index = 0; index < payList.length; index++) {
          const element = payList[index];
          if(payChannel.indexOf(element.payWay) !=-1){
            if(result.code == 0){
              let order = result.data
              let payurl = order[element.urlKey]
              this.navTobankPayPage(payurl)
            }else if(result.code == 501){
              Toast(result.msg);
            } else {
              Toast('下单失败')
            }
          }
        }
        
      }.bind(this),
      error: function(error){
        Toast('请检查网络!')
      }
    })
  },
  navTobankPayPage(href){
    let _toast = Toast.loading({
      duration: 3000, forbidClick: true, message: '正在跳转中...'
    });
    try {
      window.location.href = href
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.setAttribute('id', 'navBankLink');
      // 防止反复添加
      if(document.getElementById('navBankLink')) {
        document.body.removeChild(document.getElementById('navBankLink'));
      }
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.setAttribute('id', 'navBankLink');
      // 防止反复添加
      if(document.getElementById('navBankLink')) {
        document.body.removeChild(document.getElementById('navBankLink'));
      }
      document.body.appendChild(a);
      a.click();
    }
  },
  getUrlKey: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  },
  getDeviceType(){//获取设备类型
    let deviceType = "";
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        deviceType="android";
    }
    if (isIOS) {
        deviceType="ios";
    }
    return deviceType;
  },

  provinceForShort(province){//根据城市获取简称
    if(province == "北京市")
        return "京";
    else if(province == "天津市")
        return "津";
    else if(province == "重庆市")
        return "渝";
    else if(province == "上海市")
        return "沪";
    else if(province == "河北省")
        return "冀";
    else if(province == "山西省")
        return "晋";
    else if(province == "辽宁省")
        return "辽";
    else if(province == "吉林省")
        return "吉";
    else if(province == "黑龙江省")
        return "黑";
    else if(province == "江苏省")
        return "苏";
    else if(province == "浙江省")
        return "浙";
    else if(province == "安徽省")
        return "皖";
    else if(province == "福建省")
        return "闽";
    else if(province == "江西省")
        return "赣";
    else if(province == "山东省")
        return "鲁";
    else if(province == "河南省")
        return "豫";
    else if(province == "湖北省")
        return "鄂";
    else if(province == "湖南省")
        return "湘";
    else if(province == "广东省")
        return "粤";
    else if(province == "海南省")
        return "琼";
    else if(province == "四川省")
        return "川";
    else if(province == "贵州省")
        return "贵";
    else if(province == "云南省")
        return "云";
    else if(province == "陕西省")
        return "陕";
    else if(province == "甘肃省")
        return "甘";
    else if(province == "青海省")
        return "青";
    else if(province == "台湾省")
        return "台";
    else if(province == "内蒙古自治区")
        return "内";
    else if(province == "广西壮族自治区")
        return "桂";
    else if(province == "宁夏回族自治区")
        return "宁";
    else if(province == "新疆维吾尔自治区 ")
        return "新";
    else if(province == "西藏自治区")
        return "藏";
    else if(province == "香港特别行政区")
        return "港";
    else if(province == "澳门特别行政区")
        return "澳";
    else  return "";
  },
  getLocationWx(){
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
        var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        var speed = res.speed; // 速度，以米/每秒计
        var accuracy = res.accuracy; // 位置精度
      }
      });
      wx.openLocation({
        latitude: 0, // 纬度，浮点数，范围为90 ~ -90
        longitude: 0, // 经度，浮点数，范围为180 ~ -180。
        name: '', // 位置名
        address: '', // 地址详情说明
        scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        });
  },
  validPhone(phone){
    const reg = /^(13|14|15|17|18|19)\d{9}$/
    if(!reg.test(phone)){
      Toast('请输入正确的手机号');
      return false;
    }else{
      return true;
    }
  },
  validPassword(password){
    if (password.length<6 || password.length > 18) {
      Toast('请输入6-18位密码');
      return false;
    } else {
      return true;
    }
  },
  validEmail(email){
    var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
    if (!email) {
      Toast('请输入邮箱')
      return false;
    } else if(!reg.test(email)) {
      Toast('请输入有效邮箱')
      return false;
    } else {
      return true;
    }
  },
  timeCountDown(obj){
    const TIME_COUNT = 60; //默认倒计时秒数
    if (!obj.timer) {
        obj.waitTime = TIME_COUNT;
        obj.canGet = false;
        obj.timer = setInterval(() => {
            if (obj.waitTime>0 && obj.waitTime<=TIME_COUNT) {
                obj.waitTime--;
            }else{
                obj.canGet = true;
                clearInterval(obj.timer); //清空定时器
                obj.timer = null;
            }
        }, 1000)
    }
    return {
        timer: obj.timer,
        canGet: obj.canGet,
        waitTime: obj.waitTime
    }
  },
  uuid (len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
 
    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
    } else {
      // rfc4122, version 4 form
      var r;
 
      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
 
      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random()*16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
 
    return uuid.join('');
  },
  getAds(ad){
    if(this.browserType() !== ad.browserType && location.href.indexOf('localhost') === -1) return
    axios({
        method: 'get',
        url: ad.apiUrl, 
        success: function(res){
          if(res.code === 0 && res.data){
            if(Array.isArray(ad.imageUrl)){
              let item = {
                imageUrl: res.data.mUrl,
                adUrl: res.data.adUrl,
              }
              ad.imageUrl.push(item)
            }else{
              ad.imageUrl = res.data.mUrl
              ad.adUrl = res.data.adUrl
            }
          }
        },
        error: function(error){
            console.log(error);
        }
    })
  },
  routeToAdsPage(ad, index){
    let url = index ? ad.imageUrl[index].adUrl : ad.adUrl
    if(!url) return
    window.location.href = url
  },

};

export {
  commonUtil,
  ApiUrl
};



// WEBPACK FOOTER //
// ./src/assets/common.js